<template>
    <v-dialog v-model="dialog" max-width="610" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <v-form @submit.prevent="handleSubmit(save)">
                    <h2 class="text-center">Create Subject</h2>

                    <ValidationProvider name="Name" rules="required|max:80" v-slot="{ errors }">
                        <v-text-field label="Name"
                                      v-model="subject.name"
                                      class="mt-5"
                        >
                            <template v-slot:prepend-inner>
                                <svg v-svg="'icon-subject'" size="15" class="mr-1"></svg>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <ValidationProvider name="Icon" rules="max:80" v-slot="{ errors }">
                        <v-text-field label="Icon"
                                      v-model="subject.icon"
                        >
                            <template v-slot:prepend-inner>
                                <v-img :src="require('@/../public/images/icons/Icon.png')" class="mr-1"/>
                            </template>
                        </v-text-field>
                        <small class="font-weight-bold error--text">{{ errors[0] }}</small>
                    </ValidationProvider>

                    <v-card-actions class="d-flex justify-center mt-6">
                        <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest">Save</v-btn>
                        <v-btn class="transparent green--text ml-4" @click="dialog = false">Close</v-btn>
                    </v-card-actions>
                </v-form>
            </ValidationObserver>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        data(){
            return {
                dialog: false,
                loadingRequest: false,
                subject: {},
            }
        },

        methods: {
            save() {
                this.loadingRequest = true;
                this.$apiAdmin('subjects').create(this.subject)
                    .then(() => {
                        this.subject = {};
                        this.$refs.form.reset();
                        this.$parent.$emit('getSubjects');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully created.'});
                    }).catch((err) => {
                    if (err.response.status === 422) console.log(err.response.data);
                }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>